// extracted by mini-css-extract-plugin
export default {"providerItem":"ProviderBox_providerItem__WcEjE","icon":"ProviderBox_icon__Nx1+V"};